import { css } from "@emotion/react";

const baseButtonStyle = css`
  display: flex;
  height: 40px;
  padding-left: 16px;
  padding-right: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: #000;
  border: none;
  cursor: pointer;

  /* テキストスタイル */
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const rootStyle = css`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px 16px;
  width: 100%;
  border: 1px solid #d4d4d4;
`;

export const titleStyle = css`
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  color: #1e1e1e;
`;

export const downloadButtonStyle = css`
  ${baseButtonStyle};
  width: 100%;
  color: #fff;
`;

export const disabledDownloadButtonStyle = css`
  ${baseButtonStyle};
  width: 100%;
  background-color: #c2c2c2;
  cursor: not-allowed;
`;

export const expirationTextStyle = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

export const notExpiredTextStyle = css`
  ${expirationTextStyle};
  color: #757575;
`;

export const expiredTextStyle = css`
  ${expirationTextStyle};
  color: #e53e3e;
`;
